import { ArrayHelper } from "../../Helpers/ArrayHelper";
import { IContainerControl } from "./ContainerControl";
import { NAMESPACE } from "./_Namespace";

let
    containerControlsWhereControlsChanged: IContainerControl[] = [],
    triggerControlsChangedTimeoutId = 0;

function _triggerControlsChanged()
{
    containerControlsWhereControlsChanged = ArrayHelper.distinct(containerControlsWhereControlsChanged);

    for (let containerControl of containerControlsWhereControlsChanged)
        containerControl.trigger("controlsChanged");

    triggerControlsChangedTimeoutId = 0;
    containerControlsWhereControlsChanged = [];
}

export class ContainerControlStatic
{
    public static classNamespace = NAMESPACE + "ContainerControlStatic";
    public static className = "ContainerControlStatic";
    public static get classFullName() { return `${this.classNamespace}.${this.className}`; }

    public static _triggerControlsChanged(containerControl: IContainerControl)
    {
        containerControlsWhereControlsChanged.push(containerControl);

        if (!triggerControlsChangedTimeoutId)
            triggerControlsChangedTimeoutId = window.setTimeout(() => { _triggerControlsChanged(); });
    }
}